import React from "react";
import { Navigate } from "react-router-dom";
import { useUserContext } from "../context/UserContext";
import Dashboard1 from "../Dashboard1";
import PatientQuestionnaireList from "./patient/PatientQuestionnaireList";

const STAFF_ROLES = ["ADMIN", "MANAGER", "STAFF"];

/**
 * Root path: staff dashboard for CTMS roles; actionable questionnaire list for patient-only users.
 */
const HomeRoute = () => {
  const { roles, activePersona, canSwitchPersona } = useUserContext();
  const upper = (roles || []).map((r) => String(r || "").toUpperCase());
  const hasStaff = upper.some((r) => STAFF_ROLES.includes(r));
  const hasPatient = upper.includes("PATIENT");

  if (canSwitchPersona) {
    return activePersona === "patient" ? (
      <PatientQuestionnaireList />
    ) : (
      <Dashboard1 />
    );
  }
  if (hasStaff) {
    return <Dashboard1 />;
  }
  if (hasPatient) {
    return <PatientQuestionnaireList />;
  }
  return <Navigate to="/403" replace />;
};

export default HomeRoute;
